module.exports = __webpack_public_path__ + "statics/img/cate8-3@2x.3e4a3c78.png";